export default __webpack_public_path__ + "static/media/manufacture1.90840340.webp";